export enum EligibilityType {
  ELIGIBLE_TYPE_UNSET_TYPE = 'ELIGIBLE_TYPE_UNSET_TYPE', // Do not use, needed because of proto3 limitations
  ELIGIBLE_TO_QUEUE = 'ELIGIBLE_TO_QUEUE',
  ELIGIBLE_TO_ACTIVATE = 'ELIGIBLE_TO_ACTIVATE',
  ELIGIBLE_TO_PREPROVISION = 'ELIGIBLE_TO_PREPROVISION',
  ELIGIBLE_TO_ADD_PAYMENT = 'ELIGIBLE_TO_ADD_PAYMENT',
  NOT_ELIGIBLE = 'NOT_ELIGIBLE',
}

// To be used on getPlanEligibility's "eligibilities" filter
export enum EligibilityFilterType {
  ELIGIBLE = 'ELIGIBLE',
  NOT_ELIGIBLE = 'NOT_ELIGIBLE',
}
